import { useState } from 'react'

import BottomButton from '../common/BottomButton'
import ConnectGmailModal from './ConnectGmailModal'

export const UnlockGmailRewardsButton = ({ buttonText }: { buttonText: string }) => {
  const [showParseEnableModal, setShowParseEnableModal] = useState(false)

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <BottomButton
        style={{ height: '45px', alignProperty: 'center' }}
        className="actionButton"
        handleClick={() => setShowParseEnableModal(true)}
      >
        {buttonText}
      </BottomButton>
      <ConnectGmailModal
        isModalDisplayed={showParseEnableModal}
        hideModal={() => {
          setShowParseEnableModal(false)
        }}
      />
    </div>
  )
}
